(function($) {
    $('.js-bouton_popin').each(function() {
        var $this=$(this);
        var elementDescription = $(this).children('.desc_popin');
        var contenuPopin ="";
        if (elementDescription != null) {
            contenuPopin = elementDescription.html();
        }
        $parent = $this.parent();
        if (!$parent.is(' a') && contenuPopin != undefined) {
            $this.addClass('cliquable');
            $this.magnificPopup({
                items : {
                    src: '<div class="white-popup popin_actu mfp-figure">' + contenuPopin + '</div>',
                    type: 'inline'
                },
                image: {
                    markup: '<div class="mfp-figure">'+
                        '<div class="mfp-close"></div>'+
                        '<div class="mfp-img"></div>'+
                        '</div>',
                    tError: LOCALE_FO.galerie.display.errorImage
                },
                tClose: LOCALE_FO.galerie.controls.close,
                tLoading: LOCALE_FO.galerie.display.loading,
                gallery : {
                    enabled : false
                },
                type: 'image',
                fixedContentPos: true
            });
        }
    });
    var $target = $(window.location.hash);
    if ($target.length > 0) {
        var $boutonPopin = $target.parents('.js-bouton_popin');
        if ($boutonPopin.length > 0) {
            $boutonPopin.click();
        }
    }
})(jQuery.noConflict());
